{%  block sw_sales_channel_detail_content_tab_theme %}
    <sw-tabs-item :disabled="isProductComparison || isLoading"
                  :route="{ name: 'sw.sales.channel.detail.theme', params: { id: $route.params.id } }"
                  :title="$tc('sw-sales-channel.detail.tabTheme')">
        {{ $tc('sw-sales-channel.detail.tabTheme') }}
    </sw-tabs-item>
{% endblock %}
